export enum CouponType {
    PERCENTAGE = "percentage",  // Yüzde indirim
    FIXED = "fixed"            // Sabit tutar indirim
}

export enum CouponStatus {
    ACTIVE = "active",
    INACTIVE = "inactive",
    EXPIRED = "expired"
}

export interface CouponUsageHistory {
    companyId: number;
    usedAt: string;
    orderAmount: number;
    discountAmount: number;
}

export interface Coupon {
    id: number;
    code: string;
    name: string;
    description?: string;
    type: CouponType;
    value: number; // Yüzde için 0-100 arası, sabit tutar için TL cinsinden
    usageLimit: number; // 0 = sınırsız kullanım
    usedCount: number; // Kaç kez kullanıldı
    companyUsageLimit: number; // Bir şirket kaç kez kullanabilir
    startDate: string;
    endDate: string;
    status: CouponStatus;
    isDeleted: boolean;
    createdAt: string;
    updatedAt: string;
    usageHistory?: CouponUsageHistory[];

    //yeni
    minUserCount?: number;
    applicableProductIds?: number[];
    specificCompanyIds?: number[];
}

export interface CreateCouponDto {
    code: string;
    name: string;
    description?: string;
    type: CouponType;
    value: number;
    usageLimit?: number;
    companyUsageLimit?: number;
    startDate: string;
    endDate: string;

    //yeni
    
    minUserCount?: number;
    applicableProductIds?: number[];
    specificCompanyIds?: number[];

}

export interface UpdateCouponDto extends Partial<CreateCouponDto> {
    status?: CouponStatus;
}

export interface CouponValidationRequest {
    code: string;
    orderAmount: number;
    companyId: number;
    productId: number;
    userCount: number;
}

export interface CouponValidationResponse {
    isValid: boolean;
    message: string;
    discountAmount?: number;
    finalAmount?: number;
    coupon?: Coupon;
}

export interface CouponStats {
    totalCoupons: number;
    activeCoupons: number;
    expiredCoupons: number;
    totalUsage: number;
    totalDiscountGiven: number;
    topCoupons: Array<{
        code: string;
        name: string;
        usedCount: number;
        totalDiscount: number;
    }>;
}

export interface CouponCheckResponse {
    exists: boolean;
    coupon?: Coupon;
    message: string;
}

// Backend'den dönen kupon doğrulama sonucu
export interface CouponValidationResult {
    isValid: boolean;
    message: string;
    discountAmount?: number;
    finalAmount?: number;
    couponType?: string;
    couponValue?: string;
}
